export default "__VITE_ASSET__DiRhGnfH__"